// Tiny inline SVG sparkline component — no external chart library
export default function Sparkline({ data, color = "#0F766E", height = 30, width = 100, testid }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = Math.max(max - min, 1);
  const step = width / Math.max(data.length - 1, 1);
  const points = data.map((v, i) => `${i * step},${height - ((v - min) / range) * (height - 4) - 2}`).join(" ");
  const areaPoints = `0,${height} ${points} ${width},${height}`;
  const last = data[data.length - 1];
  const prev = data[data.length - 2] || last;
  const delta = last - prev;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} className="sparkline" data-testid={testid}>
      <polygon points={areaPoints} fill={color} opacity="0.12" />
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={(data.length - 1) * step} cy={height - ((last - min) / range) * (height - 4) - 2} r="2.5" fill={color} />
      {delta !== 0 && (
        <text x={width - 2} y={11} textAnchor="end" fontSize="9" fontFamily="'DM Mono'" fill={delta > 0 ? "#3a7647" : "#b04a3f"}>
          {delta > 0 ? "▲" : "▼"} {Math.abs(delta)}
        </text>
      )}
    </svg>
  );
}
